import {
  flexRender,
  type HeaderContext,
  type RowData,
  type StockFeatures,
} from '@tanstack/react-table';
import { type ReactNode } from 'react';
import { Tooltip } from '../Tooltip';

export type TableHeaderTooltipProps<TData extends RowData, TValue> = {
  tooltip?: ReactNode;
  customTooltip?: ReactNode;
  context: HeaderContext<StockFeatures, TData, TValue>;
};

export const TableHeaderTooltip = <TData extends RowData, TValue>(
  props: TableHeaderTooltipProps<TData, TValue> | undefined,
) => {
  if (!props) return null;

  const { tooltip, customTooltip, context } = props;

  if (tooltip) return <Tooltip>{tooltip}</Tooltip>;
  else if (customTooltip) {
    return <>{flexRender(customTooltip, context)}</>;
  }
};
